<template>
<div class="kcb-cert">
    <div v-if="show" class="kcb-cert__screen">
        <iframe :src="src" class="kcb-cert__iframe" frameborder="0" scrolling="yes"></iframe>
        <button type="button" class="kcb-cert__close" aria-label="닫기" @click="close">&times;</button>
    </div>
    <slot name="activator" :on="{ click: open }" />
</div>
</template>

<script>
// KCB 휴대폰본인확인(표준창) — 쿠콘 경유. kcp-cert.vue 와 같은 인터페이스(open(), input/complete/change 이벤트, payload 형태).
// PC 는 새 창, 모바일은 화면 위 iframe 으로 띄운다.
// 대한문고 앱 WebView(안드로이드·iOS)가 window.open 을 새 창이 아니라 지금 화면에서 열어서, 새 창 방식이면 opener 가 없어 결과를 못 받고 빈 응답 페이지에 갇힌다.
// iframe 안에서는 window.close() 가 듣지 않으므로 응답·요청 페이지가 부모의 authClose 를 불러 닫는다. KCB 창의 취소로 닫히지 않을 때를 위해 닫기 버튼을 둔다.
export default {
    data() {
        return {
            show: false,
            src: "",
        };
    },
    mounted() {
        window.authComplete = (payload) => {
            this.close();
            this.$emit("complete", payload);
            this.$emit("change", payload);
            this.$emit("input", payload);
        };
        window.authClose = () => this.close();
    },
    beforeDestroy() {
        window.authComplete = undefined;
        window.authClose = undefined;
    },
    methods: {
        // 팝업 차단을 피하려면 클릭 처리 안에서 동기적으로 열어야 한다. API 호출은 열린 창(request 페이지)이 한다.
        open() {
            const isMobile = navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("iPhone") > -1;

            if (isMobile) {
                this.src = `/plugins/kcb/cert/request?t=${Date.now()}`;
                this.show = true;
                return;
            }

            const width = 430;
            const height = 640;
            const left = screen.width / 2 - width / 2;
            const top = screen.height / 2 - height / 2;
            const feature = `width=${width}, height=${height}, toolbar=no, status=no, statusbar=no, menubar=no, scrollbars=yes, resizable=no, left=${left}, top=${top}`;

            window.open("/plugins/kcb/cert/request", "auth_popup", feature);
        },
        auth() {
            this.open();
        },
        close() {
            this.show = false;
            this.src = "";
        },
    },
};
</script>

<style>
.kcb-cert__screen {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
    background: #fff;
}
.kcb-cert__iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
}
.kcb-cert__close {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.54);
    color: #fff;
    font-size: 24px;
    line-height: 36px;
    text-align: center;
}
</style>
